import { render, staticRenderFns } from "./areaCounts.vue?vue&type=template&id=760318e6&scoped=true&"
import script from "./areaCounts.vue?vue&type=script&lang=js&"
export * from "./areaCounts.vue?vue&type=script&lang=js&"
import style0 from "./areaCounts.vue?vue&type=style&index=0&id=760318e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760318e6",
  null
  
)

component.options.__file = "areaCounts.vue"
export default component.exports